/**
 * Included into the footer of pages.
 */

import * as variables from './variables';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.applyAttributes(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import Scrolled from './lib/Scrolled';
new Scrolled({
	scrolledClass: 'has-scrolled',
	scrolledDistanceClass: 'has-scrolled-distance',
	scrollDistanceDown: 20,
	scrollDistanceUp: 20
});

import initMasonry from './component/masonry';
initMasonry();

import "./component/formatted-inputs";

import {videoModals} from "./component/VideoModal/VideoModal";
videoModals({
	// If you want a custom play button, uncomment this line
	customPlayButton: require("./component/VideoModal/assets/video-play-button.svg?string")
});

/* Make dialog ::backdrop's clickable globally (when they are present on page load) */
const dialogs = document.querySelectorAll<HTMLDialogElement>('dialog');
dialogs.forEach((dialog) => {
	dialog.addEventListener('click', (event: MouseEvent) => {
		const rect = dialog.getBoundingClientRect();
		const isInDialog = (
			rect.top <= event.clientY &&
			event.clientY <= rect.top + rect.height &&
			rect.left <= event.clientX &&
			event.clientX <= rect.left + rect.width
		);

		if (!isInDialog) {
			dialog.close();
		}
	});
});

const searchParams = new URLSearchParams(window.location.search);
if (searchParams.size) { //Most of the time, we don't have any query parameters at all, so we can skip the loop
	for (const param of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid']) {
		if (searchParams.has(param)) {
			sessionStorage.setItem(param, searchParams.get(param) ?? '');
		}
	}
}


// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance([
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .site-footer__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .site-footer__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// ]);
// ---------------------------------------------------------------------------------------------- //
